__turbopack_context__.v({
  "container": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__container",
  "description": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__description",
  "header": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__header",
  "progressTrack": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__progressTrack",
  "rateInput": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__rateInput",
  "slider": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__slider",
  "sliderInput": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__sliderInput",
  "sliderWrapper": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__sliderWrapper",
  "tickMarkActive": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__tickMarkActive",
  "title": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__title",
  "trackContainer": "FinanceQuoteTermSlider-module-scss-module__nH7eaq__trackContainer",
});
